const initNewsletterForms = () => {
  const forms = document.querySelectorAll('.newsletter-embed');

  // validate recaptcha
  function validateCaptcha() {
    return new Promise((res, rej) => {
      if(typeof grecaptcha === 'undefined') {
        return res('');
      }

      grecaptcha.ready(() => {
        grecaptcha.execute('6LfT9PsqAAAAAFPziGcG8AmACKdlKV6q3515rsL2', { action: 'submit' }).then((token) => {
          return res(token);
        });
      });
    });
  }

  function validateEmail(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  }

  if(forms && forms.length > 0) {
    for(var i = 0; i < forms.length; i++) {
      let form = forms[i];

      let emailInput = form.querySelector('input[type="email"]');
      emailInput.addEventListener('input', function() {
        if(validateEmail(this.value)) {
          form.classList.add('valid');
        } else {
          form.classList.remove('valid');
        }
      });
      emailInput.addEventListener('change', function() {
        if(validateEmail(this.value)) {
          form.classList.add('valid');
        } else {
          form.classList.remove('valid');
        }
      });

      form.addEventListener('submit', async function (event) {
        event.preventDefault();

        form.classList.add('submitting');

        let token = await validateCaptcha();

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const email = form.querySelector('input[type="email"]').value;
        const campaign = form.querySelector('input[name="campaign"]').value;
        const url = `https://us-central1-arnolds-pump-club.cloudfunctions.net/newsletter?action=createSubscription`;

        const data = {
          token: token,
          email: email,
          reactivate_existing: true,
          send_welcome_email: true,
          utm_source: 'arnoldspumpclub.com',
          utm_medium: 'referral',
          utm_campaign: campaign,
          referring_site: 'https://arnoldspumpclub.com',
        };

        // Specific handler for custom fields
        if(campaign == "Sold Out Notification") {
          data.custom_fields = [
            {
              "name": "Stock Notifications",
              "value": "true"
            }
          ]
        }

        var requestOptions = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data),
          redirect: 'follow',
        };

        // console.log('requestOptions:', requestOptions);

        const result = await fetch(url, requestOptions)
          .then((response) => response.json())
          .then((result) => result)
          .catch((error) => console.log('error', error));

        form.classList.remove('submitting');

        // console.log('result:', result);

        if(result.data.status === 'active' || result.data.status === 'pending' || result.data.status === 'validating') {

          // Hide the form
          form.classList.add('inactive');
          // Show the success message
          form.querySelector('.success-message').classList.add('active');
          // Redirect to confirmation page
          window.location.href = 'https://arnoldspumpclub.com/pages/almost-there';
        } else {
          // Hide the form
          form.classList.add('inactive');
          // Show the error message
          form.querySelector('.error-message').classList.add('active');

          setTimeout(function() {
            // Show the form
            form.classList.remove('inactive');
            // Hide the error message
            form.querySelector('.error-message').classList.remove('active');
          }, 5000);
        }

      });
    }
  }
};

export { initNewsletterForms };